<!-- 弹出层组件 -->
<template>
  <div v-if="open" class="popUp">
    <div class="popup-bottom-wrapper">
      <div class="popup-bottom-content">
        <div class="popup-bottom-logo">
          <img src="@/assets/images/pop-success.png" alt="" v-if="popupStatus == 'success'">
          <img src="@/assets/images/warn.png" alt="" v-else-if="popupStatus == 'warn'">
          <img src="@/assets/images/pop-fail.png" v-else alt="">
        </div>
        <div class="popup-bottom-content-title">{{ popupTitle }}</div>
        <div class="popup-bottom-content-text">{{ popupText }}</div>
        <div class="popup-bottom-content-text" style="margin-top: 4px;" v-if="billingAddress">
          {{ $t('message.checkout.billingAddressTip', {
            billingAddress: billingAddress
          }) }}
        </div>
        <!-- 倒计时文案 -->
        <div class="popup-bottom-content-text countdown-text" v-if="showCountdownText"
          v-html="$t('message.result.autoRedirectCountdown', { seconds: `<span class='countdown-number'>${countdown}</span>` })">
        </div>
        <!-- 自定义按钮 -->
        <div class="popup-bottom-content-btn" v-if="showCustomBtn" @click="handleCustomButtonClick">
          {{ customButtonText }}
        </div>
        <!-- 原有的返回/跳转按钮 -->
        <div class="popup-bottom-content-btn" v-if="showReturnBtn" @click="routeTo">
          {{ $t('message.checkout.returnMerchant') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'popupBottom',
  props: {
    showReturnBtn: {
      type: Boolean,
      default: true,
    },
    open: {
      type: Boolean,
      default: true,
    },
    popupStatus: {
      type: String,
      default: '',
    },
    popupTitle: {
      type: String,
      default: '',
    },
    popupText: {
      type: String,
      default: '',
    },
    billingAddress: {
      type: String,
      default: '',
    },
    redirectUrl: {
      type: String,
      default: '',
    },
    showCustomBtn: {
      type: Boolean,
      default: false,
    },
    customButtonText: {
      type: String,
      default: 'OK',
    },
    // 订单信息对象
    order: {
      type: Object,
      default: null,
    },
    // 自动跳转倒计时秒数
    autoRedirectSeconds: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      // 当前倒计时数值
      countdown: 0,
      // 定时器引用
      countdownTimer: null,
    };
  },
  computed: {
    ...mapGetters(['app']),
    // 是否启用自动跳转功能（从brandInfo中获取）
    autoRedirect() {
      return this.app.brandInfo?.autoRedirect === true;
    },
    // 是否显示倒计时文案
    showCountdownText() {
      return this.app.brandInfo?.autoRedirect === true;
    },
  },
  watch: {
    open(val) {
      if (val && this.autoRedirect) {
        // 如果启用自动跳转，开始倒计时
        this.startCountdown();
      } else {
        // 清除倒计时
        this.clearCountdown();
      }
    },
  },
  methods: {
    routeTo() {
      if (this.redirectUrl) {
        window.location.href = this.redirectUrl;
      }
    },

    /**
     * 处理自定义按钮点击事件
     * @author Nemo
     * @date 2025-07-11
     */
    handleCustomButtonClick() {
      this.$emit('custom-button-click');
    },

    // 开始倒计时
    startCountdown() {
      if (!this.autoRedirect) return;

      this.countdown = this.autoRedirectSeconds;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.clearCountdown();
          // 自动执行跳转
          this.routeTo();
        }
      }, 1000);
    },

    // 清除倒计时
    clearCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.countdown = 0;
    },
  },
  beforeDestroy() {
    // 清除定时器防止内存泄漏
    this.clearCountdown();
  },
};
</script>
<style lang="scss" scoped>
.popUp {
  width: 100%;
  z-index: 10000;
  background: rgba(102, 112, 133, 0.7);
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  backdrop-filter: blur(10px);

}

.popup-bottom-wrapper {
  width: 100%;
  background-color: white;
  position: fixed;
  bottom: 0;
  // min-height: 278px;
  background: #FFFFFF;
  box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.05);
  border-radius: 20px 20px 0px 0px;
  padding: 24px;
  box-sizing: border-box;
  text-align: left;

  .popup-bottom-logo {
    width: 40px;
    height: 40px;

    img {
      width: 100%;
    }
  }

  .popup-bottom-content-title {
    font-weight: 600;
    font-size: 20px;
    color: #1A202C;
    margin-top: 16px;
    line-height: 30px;
  }

  .popup-bottom-content-text {
    font-weight: 400;
    font-size: 14px;
    color: #667085;
    line-height: 18px;
    margin-top: 16px;

  }

  .popup-bottom-content-btn {
    width: 100%;
    height: 44px;
    line-height: 44px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px 8px 8px 8px;
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 16px;
    background: #182058;
  }

  .countdown-text {
    margin-left: 4px;

    :deep(.countdown-number) {
      color: var(--brand-color, #503df6);
      font-weight: 700;
    }
  }

}
</style>
